// JsFromRoutes CacheKey e6f033e13057e17edcd87594948ec3f3
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  invite: /* #__PURE__ */ definePathHelper('post', '/brokers/employers/invite'),
  index: /* #__PURE__ */ definePathHelper('get', '/brokers/employers'),
}
